﻿import document from 'document';
import { getChild } from '../../utilities/selector';

export const driverValidation = () => {

    const selectors = {
        container: "driverFields",
        toggleClass: "driver-fields__optional",
        driverName: "DriverName",
        driverEmail: "DriverEmail",
        contactNumber: "DriverContactNumber",
        skipValidation: "skip-validation",
        btnYes: "optYes",
        btnNo: "optNo",
        addressLookup: "#AddressLookup"
    }

    const yes = "yes";
    const no = "no";

    const toggleDriverValidation = (choice) => {

        var container = document.getElementById(selectors.container);
        var nameField = document.getElementById(selectors.driverName);
        var emailField = document.getElementById(selectors.driverEmail);
        var contact = document.getElementById(selectors.contactNumber);
        const driverInput  = getChild(container, selectors.addressLookup);
        const addressContainer = getChild(container, '.form-field-group--address');

        if (choice == no) {
            container.classList.remove(selectors.toggleClass);
            nameField.removeAttribute(selectors.skipValidation);
            emailField.removeAttribute(selectors.skipValidation);
            contact.removeAttribute(selectors.skipValidation);
            driverInput.removeAttribute(selectors.skipValidation);
            addressContainer.setAttribute('data-required', "true");
        } else {
            container.classList.add(selectors.toggleClass);
            nameField.setAttribute(selectors.skipValidation, "true");
            emailField.setAttribute(selectors.skipValidation, "true");
            contact.setAttribute(selectors.skipValidation, "true");
            driverInput.setAttribute(selectors.skipValidation, "true");
            addressContainer.setAttribute('data-required', "false");
        }
    }

    const init = () => {
        const noButton = document.getElementById(selectors.btnNo);
        const yesButton = document.getElementById(selectors.btnYes);

        if (noButton && yesButton) {
            noButton.addEventListener('click', () => { toggleDriverValidation(no); });
            yesButton.addEventListener('click', () => { toggleDriverValidation(yes); });
        }
    };

    return {
        init
    };
}
